/** Телефон обраного клієнта або введений рядок пошуку (для apply-discount). */
export const resolveDiscountUserIdentity = (selectedUser, searchQuery) =>
  (selectedUser?.phoneNumber || searchQuery || '').trim();

/**
 * Локальний % знижки з урахуванням «Дозволити збільшити вартість».
 * 100% → 1 грн.
 */
export const calcPercentDiscountedPrice = (price, currentDiscountedPrice, discountPercent, forceIncrease) => {
  const discount = Number(discountPercent);
  if (discount === 100) return 1;
  const priceWithDiscount = Math.ceil((price * (100 - discount)) / 100);
  if (priceWithDiscount < currentDiscountedPrice) return priceWithDiscount;
  return forceIncrease ? priceWithDiscount : currentDiscountedPrice;
};

/** @returns {{ ok: true, percent: number } | { ok: false }} */
export const parseDiscountPercent = (value) => {
  if (value === '' || value == null) return { ok: false };
  const percent = Number(value);
  if (Number.isNaN(percent) || percent < 0 || percent > 100) return { ok: false };
  return { ok: true, percent };
};

export const buildApplyDiscountQuery = ({ discountLevel, userIdentity }) => {
  if (discountLevel !== undefined && discountLevel !== null && String(discountLevel) !== '') {
    return 'discountLevel=' + encodeURIComponent(discountLevel);
  }
  return 'userIdentity=' + encodeURIComponent(userIdentity || '');
};
